import React from "react";
import Header from "./components/Header";
import Content from "./components/Content";

function App() {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
}

export default App;
